export const dealPaidStatusToColor: { [key: string]: string } = {
  Current: '#5CAA5B',
  Paid: '#5CAA5B',
  InCollection: '#DCAC00',
  Default: '#EE0056',
  FullyPaid: '#47BA00',
  ProcessingRenewal: '#4C5878',
}

export const dealPaidStatusToLabelColor: { [key: string]: string } = {
  Current: '#A5CEA4',
  InCollection: '#EFCF2F',
  Default: '#991212',
  FullyPaid: '#5CAA5B',
  ProcessingRenewal: '#EEA237',
}

export const dealStatusToLabelColor: { [key: string]: string } = {
  New: '#136DB2',
  Declined: '#FA5252',
  Approved: '#A5CEA4',
  OuthouseFunded: '#C9C9C7',
  InUnderwriting: '#249AF3',
  ReadyToFund: '#8FC2E9'
}

export const envelopeStatusToContractStatus: { [key: string]: string } = {
  sent: 'Sent',
  delivered: 'Viewed',
  completed: 'Signed'
}

export const contractStatuseToLabelColor: { [key: string]: string } = {
  sent: '#99EEF3',
  delivered: '#D0CAFF',
  completed: '#7F4CC1'
}
